import React from 'react'
import ResetPassword from './ResetPassword/ResetPassword'
import {Switch, Route, Redirect} from 'react-router-dom'
import {Grid, Hidden} from '@material-ui/core'
import RegistryInfo from './RegistryInfo'
import SignUp from './SignUp'
import Login from './Login'
import Footer from '../components/Footer'
import ForgotPassword from './ForgotPassword'
import BackEnd from './BackEnd'
import SignIn from './SignIn'
import Info from './Info'
import {useSettings} from '../utils/Settings'
import Particles from 'react-particles-js'
import Logo from '../components/Logo'
import OutReach from './OutReach/OutReach'

const particleOpt = {
    particles: {
        number: {
            value: 80,
            density: {
                enable: true,
                value_area: 710,
            },
        },
        color: {
            value: '#d3e3f2',
        },
        shape: {
            type: 'circle',
            stroke: {
                width: 1,
                color: '#f9f9f9',
            },
        },
        polygon: {
            nb_sides: 6,
        },
        opacity: {
            value: 1,
            random: true,
        },
        size: {
            value: 10,
            random: true,
        },
        line_linked: {
            distance: 150,
            color: '#e2e9ee',
            opacity: 1,
        },
    },
}

const Authentication = props => {
    const {appConfig, logged} = useSettings()

    if (logged === true) {
        // console.log('logged true')
        // console.log(process.env.REACT_APP_ISMYACCOUNT)
        if (process.env.REACT_APP_ISMYACCOUNT === 'yes') {
            return <Redirect to="/myaccount" />
        }
        return <Redirect to="/onboard/welcome" />
    }

    const loginPath =
        process.env.REACT_APP_ISMYACCOUNT === 'yes' ? '/login-my-account' : '/login'
    return (
        <React.Fragment>
            {appConfig.customization.particles === true ? (
                <Grid className="particles_wrapper">
                    <Particles params={particleOpt} />
                </Grid>
            ) : (
                <div className="particles-bg"></div>
            )}

            <Grid container className="login--signin  login--page">
                <Grid container className="login--signin__row">
                    <Grid item xs={12} md>
                        <Grid
                            container
                            justify="center"
                            alignItems="center"
                            className="login__wrapper-1"
                        >
                            <Grid item className="login__contanier">
                                <Grid item xs={12} className="login__logo">
                                    <Logo imgSrc={appConfig.logoUrl} />
                                </Grid>
                                <Grid item className="login__contanier-info">
                                    <RegistryInfo registryInfo={appConfig.registryInfo} />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Hidden only={['sm', 'xs']}>
                        <Grid item className="login--page--ver__divider" />
                    </Hidden>
                    <Grid item xs={12} md>
                        <Grid
                            container
                            justify="center"
                            alignItems="center"
                            className="login__wrapper-2"
                            id="home"
                        >
                            <Switch>
                                <Route exact path={loginPath} component={Login} />
                                <Route exact path="/info" component={Info} />
                                <Route
                                    exact
                                    path="/forgotpassword"
                                    component={ForgotPassword}
                                />
                                <Route
                                    exact
                                    path="/resetpassword"
                                    component={ResetPassword}
                                />
                                <Route path="/registration" component={BackEnd} />
                                <Route path="/signin" component={SignIn} />
                                <Route path="/outreach/:unit?" component={OutReach} />
                                <Route exact path="/" component={SignUp} />
                                <Route
                                    render={() => (
                                        <>
                                            <p>404 | Page Not Found</p>
                                        </>
                                    )}
                                />
                            </Switch>
                        </Grid>
                    </Grid>
                </Grid>{' '}
                {appConfig.customization.footer && (
                    <Grid container className="footer-copyright">
                        <Grid item xs={12}>
                            <Footer footer={appConfig} />
                        </Grid>
                    </Grid>
                )}
            </Grid>
        </React.Fragment>
    )
}

export default Authentication
